<template>
  <div class="printer-code-pages-settings">
    <div class="text-subtitle-1 mb-2">
      {{ label }}
    </div>
    <v-simple-table dense class="printer-code-pages-settings__table">
      <template v-slot:default>
        <thead>
          <tr>
            <th>Номер устройства</th>
            <th>Кодовая страница (ESC t N)</th>
            <th class="printer-code-pages-settings__actions" />
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, i) in rows" :key="`pcp-${i}`">
            <td>
              <v-text-field
                v-model.number="row.deviceNumber"
                type="number"
                min="0"
                dense
                outlined
                hide-details
                :disabled="disabled"
                @input="emitValue"
              />
            </td>
            <td>
              <v-text-field
                v-model.number="row.codePage"
                type="number"
                min="0"
                max="255"
                dense
                outlined
                hide-details
                :disabled="disabled"
                @input="emitValue"
              />
            </td>
            <td class="printer-code-pages-settings__actions">
              <v-btn
                icon
                :disabled="disabled"
                @click="removeRow(i)"
              >
                <v-icon color="#EB5757">
                  mdi-trash-can-outline
                </v-icon>
              </v-btn>
            </td>
          </tr>
          <tr v-if="!rows.length">
            <td colspan="3" class="text--secondary">
              Страницы не заданы, принтеры печатают в своей кодировке
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-btn
      class="printer-code-pages-settings__add mt-2"
      type="button"
      text
      :disabled="disabled"
      @click.stop="addRow"
    >
      <v-icon left>
        mdi-plus
      </v-icon>
      Добавить строку
    </v-btn>
    <div v-if="errorMessage" class="error--text text-caption pa-2">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PrinterCodePagesSettings',
    props: {
      value: {
        type: [String, Array],
        default: () => [],
      },
      label: {
        type: String,
        default: 'Кодовые страницы принтеров чеков',
      },
      disabled: Boolean,
    },
    data () {
      return {
        rows: [],
      }
    },
    computed: {
      errorMessage () {
        if (this.disabled) return null

        const devices = this.rows.map((r) => r.deviceNumber)
        if (new Set(devices).size !== devices.length) {
          return 'Номер устройства не должен повторяться'
        }
        if (this.rows.some((r) => r.codePage === '' || r.codePage < 0 || r.codePage > 255)) {
          return 'Кодовая страница — число от 0 до 255'
        }
        if (this.rows.some((r) => r.deviceNumber === '' || r.deviceNumber < 0)) {
          return 'Номер устройства — целое число от 0'
        }
        return null
      },
    },
    watch: {
      value: {
        handler (val) {
          this.parseValue(val)
        },
        deep: true,
        immediate: true,
      },
    },
    methods: {
      parseValue (val) {
        let parsed = val
        if (typeof val === 'string') {
          try {
            parsed = JSON.parse(val)
          } catch (e) {
            parsed = []
          }
        }
        if (!Array.isArray(parsed)) parsed = []

        const next = parsed.map((r) => ({
          deviceNumber: r?.deviceNumber ?? '',
          codePage: r?.codePage ?? '',
        }))
        // своё же изменение прилетает обратно через v-model - не пересобирать строки
        if (JSON.stringify(next) === JSON.stringify(this.rows)) return
        this.rows = next
      },
      addRow () {
        this.rows.push({ deviceNumber: '', codePage: '' })
        this.emitValue()
      },
      removeRow (i) {
        this.rows.splice(i, 1)
        this.emitValue()
      },
      emitValue () {
        const result = this.rows.map((r) => ({
          deviceNumber: r.deviceNumber,
          codePage: r.codePage,
        }))
        this.$emit('input', typeof this.value === 'string' ? JSON.stringify(result) : result)
      },
    },
  }
</script>

<style scoped lang="less">
.printer-code-pages-settings {
  &__table {
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 4px;
  }

  // селектор длиннее вьютифаевского, иначе его padding: 0 16px побеждает
  &__table.v-data-table > ::v-deep .v-data-table__wrapper > table > tbody > tr > td {
    padding: 8px 12px;
  }

  &__actions {
    width: 56px;
  }

  &__add.v-btn {
    text-transform: none;
    letter-spacing: normal;
  }
}
</style>
